module.exports = __webpack_public_path__ + "static/media/historyMobile.50faf807.png";